import { Grid, Typography } from "@mui/material";
import { Panel } from "@poseidon/ui/components";
import MultiFileSummary from "../Files/MultiFileSummary";
import dealerConfig from "./config.json";
import { camelToSentenceCase } from "@poseidon/utils/text";
import DealerAction from "./DealerAction";
import config from "@poseidon/utils/config";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import * as React from "react";
import { FileManagementDealer } from "./FileManagementDealer";
import { capitalizeFirstLetter } from "@poseidon/utils/string";
import { useState } from "react";

function FilesDialog({ application, fileCategory, fileGroup, open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "max(50vw, 480px)",
          maxWidth: "min(95vw, 800px)",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        {fileGroup ? `${capitalizeFirstLetter(fileGroup)} File Management` : ""}
      </DialogTitle>
      <DialogContent>
        {fileGroup && (
          <FileManagementDealer
            application={application}
            fileCategory={fileCategory}
            fileGroup={fileGroup}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export const DealerBoatDocumentationSection = ({ application }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    fileGroup: null,
  });
  return (
    <Panel title="Boat Documentation">
      <Typography variant="p">Please provide the following files:</Typography>
      <Grid container spacing={2} mt={0}>
        {dealerConfig.fileGroups.map((group) => (
          <Grid key={group} item xs={12} sm={6}>
            <MultiFileSummary
              handleOnClick={() => {
                setDialogState({
                  open: true,
                  fileGroup: group,
                });
              }}
              fieldLabel={camelToSentenceCase(group)}
            />
          </Grid>
        ))}
      </Grid>
      <FilesDialog
        open={dialogState.open}
        application={application}
        fileCategory="application"
        fileGroup={dialogState.fileGroup}
        onClose={() => {
          setDialogState({
            open: false,
            fileGroup: null,
          });
        }}
      />
      <DealerAction
        entity={config.SaltCollection.Application}
        entityId={application?.id}
        entityKey="boatDocumentation"
        sx={{ mt: 2 }}
      />
    </Panel>
  );
};
